<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import ChatTranscript from './ChatTranscript.vue'
import { useChatStore } from '@/stores/chat'
import { isLoaded } from '@/types/load-state'

const chat = useChatStore()
const router = useRouter()

const messages = computed(() => (isLoaded(chat.messages) ? chat.messages.value : []))

const isStreamingTurn = computed(
  () => chat.sendStatus === 'submitting' || chat.sendStatus === 'streaming',
)

const settledAction = computed(() =>
  chat.visibleAction && chat.visibleAction.status !== 'pending' ? chat.visibleAction : undefined,
)

const settledQuestion = computed(() =>
  chat.visibleQuestion && chat.visibleQuestion.status !== 'pending'
    ? chat.visibleQuestion
    : undefined,
)

const settledConnect = computed(() =>
  chat.visibleConnect && chat.visibleConnect.status !== 'pending' ? chat.visibleConnect : undefined,
)

function openKnowledgePage(slug: string): void {
  void router.push({ name: 'document-page', params: { slug } })
}
</script>

<template>
  <ChatTranscript
    :messages="messages"
    :live-steps="chat.liveSteps"
    :live-outcomes="chat.liveOutcomes"
    :streaming-text="chat.streamingText"
    :streaming="isStreamingTurn"
    :settled-action="settledAction"
    :settled-question="settledQuestion"
    :settled-connect="settledConnect"
    @open-knowledge="openKnowledgePage"
  />
</template>
